import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Container from 'reactstrap/lib/Container';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import { connectToModel } from 'client/data/luckdragon/redux/react-binding';
import { bindToContent, CmsEntities } from 'client/data/models/cms';
import { getMobileArticleContentPath } from 'site-modules/editorial/utils/content-path';
import { getMobileArticleBreadcrumbs } from 'site-modules/editorial/utils/breadcrumbs';
import { TrackingHandler } from 'client/tracking/handler';
import { CommonMap } from 'client/tracking/maps/common';
import { Breadcrumbs } from 'site-modules/shared/components/breadcrumbs/breadcrumbs';
import { Link } from 'site-modules/shared/components/link/link';
import { ResearchEntry } from 'site-modules/editorial/components/about-article/research-entry/research-entry';

import './mobile-article.scss';

const MOBILE_ARTICLES_LINKS = [
  { articleId: 'featured', label: 'Featured' },
  { articleId: 'apps', label: 'Apps' },
  { articleId: 'web', label: 'Mobile Web' },
];

function MobileArticleUI({ content = null, articleId }) {
  useEffect(() => {
    TrackingHandler.useMap(CommonMap);
  }, []);

  if (!content) {
    return null;
  }

  const { title } = content;
  const mainEntries = content.child('main').children();
  const rightRailEntries = content.child('right-rail').children();
  const footerEntries = content.child('footer').children();

  return (
    <Container tag="main" id="main-content" tabIndex={-1} className="mobile-article pb-2">
      <Breadcrumbs className="px-0 mb-2" data={getMobileArticleBreadcrumbs({ articleId, title })} />
      <h1 className="heading-2 mb-1_5">{title}</h1>
      <Row>
        <Col xs={12} lg={8} className="mb-1_5">
          <ul className="mobile-nav list-unstyled d-flex text-gray-darker mb-2 w-100">
            {MOBILE_ARTICLES_LINKS.map(({ articleId: linkArticleId, label }) => (
              <li key={`nav-${linkArticleId}`} className="px-1">
                {articleId === linkArticleId ? (
                  label
                ) : (
                  <Link className="text-primary-darker" to={`/mobile/${linkArticleId}.html`}>
                    {label}
                  </Link>
                )}
              </li>
            ))}
          </ul>
          {/* main */}
          {mainEntries.map((entry, index) => {
            const key = `main-${entry.id}-${index}`;

            return <ResearchEntry key={key} entry={entry} />;
          })}
        </Col>
        <Col xs={12} lg={4} className="mb-1_5">
          {/* right-rail */}
          {rightRailEntries.map((entry, index) => {
            const key = `right-rail-${entry.id}-${index}`;

            return <ResearchEntry key={key} entry={entry} />;
          })}
        </Col>
        <Col xs={12} lg={8}>
          {/* footer */}
          {footerEntries.map((entry, index) => {
            const key = `footer-${entry.id}-${index}`;

            return <ResearchEntry key={key} entry={entry} />;
          })}
        </Col>
      </Row>
    </Container>
  );
}

MobileArticleUI.propTypes = {
  articleId: PropTypes.string.isRequired,
  content: CmsEntities.Content,
};

export const MobileArticle = connectToModel(MobileArticleUI, {
  content: bindToContent(({ articleId }) => getMobileArticleContentPath(articleId)),
});
